import React from "react";
import heroImage from "../../../assets/img10.jpg";
import { CheckCircle } from "lucide-react";
import missionImg from "../../../assets/img73.jpg";
import visionImg from "../../../assets/img74.jpg";
import { Link } from "react-router-dom";
import img10 from "../../../assets/img10.jpg";
import SEO from "../../../components/SEO";
function AboutUs() {
  return (
    <>
   <SEO
  title="À propos de nous | einsured.ca Canada"
  description="Découvrez einsured.ca, votre partenaire en assurance-vie, voyage et investissements. Explorez des solutions personnalisées pour vous protéger, vous et vos proches."   
/>
    <div className="w-full">
      <section
        className="relative w-full min-h-[320px] md:min-h-[420px] flex items-start"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />

        <div className="relative w-full px-4 sm:px-8 lg:px-60 pt-10 md:pt-24 pb-16 md:pb-20">
          <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight">
            À propos de nous
          </h1>

          <p className="mt-3 md:mt-4 text-sm md:text-lg font-semibold text-white">
            einsured.ca, votre partenaire fiable pour naviguer dans le monde complexe de l'assurance
          </p>

          <a
            href="https://book.einsured.ca/widget/bookings/ei-team"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-5 md:mt-6 px-8 md:px-10 py-3 md:py-3.5 rounded-full text-sm md:text-base font-semibold text-white bg-[#00C2FF] hover:bg-[#00AEE5] transition w-full sm:w-auto text-center"
          >
            Contactez-nous maintenant !
          </a>
        </div>
      </section>

      {/* Bienvenue sur einsured.ca */}
<section className=" py-12 md:py-16">
  <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
    <h2 className="text-2xl md:text-3xl font-bold text-[#49628b]">
      Bienvenue sur einsured.ca !
    </h2>

    <p className="mt-3 text-sm md:text-base font-semibold text-[#49628b]">
      Votre chemin vers un avenir sécurisé commence ici
    </p>

    <p className="mt-6 text-sm md:text-base leading-relaxed text-slate-700">
      Bienvenue sur{" "}
      <a
        href="/"
        className="text-[#49628b] underline hover:text-[#1e3a63]"
      >
        einsured.ca
      </a>
      , votre partenaire fiable pour naviguer dans le monde complexe de
      l'assurance. Fondée en 2018, nous avons établi une position de premier
      plan dans le secteur de l'assurance, en offrant des solutions
      d'assurance personnalisées et complètes qui protègent votre avenir.
      Notre engagement indéfectible est de donner aux particuliers, aux
      familles et aux entreprises la protection et la tranquillité d'esprit
      qu'ils méritent.
    </p>

    <p className="mt-4 text-sm md:text-base leading-relaxed text-slate-700">
      einsured.ca est autorisée à vendre en Alberta, en Colombie-Britannique,
      au Manitoba, en Ontario, au Québec et en Saskatchewan. Pour le reste du
      Canada, les services sont fournis par nos autres partenaires
      d'assurance qui y sont autorisés.
    </p>
  </div>
</section>

{/* Notre mission */}
<section className="py-12 md:py-16">
  <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center gap-8 md:gap-12">
    <div className="md:w-1/2">
      <h2 className="text-2xl md:text-3xl font-bold text-[#49628b] mb-4">
        Notre mission
      </h2>
      <p className="text-sm md:text-base leading-relaxed text-slate-700">
        Chez einsured.ca, notre mission est simple mais profonde : offrir des
        solutions d'assurance sur mesure qui répondent aux besoins uniques de
        nos clients. Nous croyons en l'établissement de relations durables
        fondées sur la confiance, la transparence et un service exceptionnel.
        Notre équipe de professionnels dévoués s'engage à faire l'effort
        supplémentaire pour assurer votre entière satisfaction et sécurité.
      </p>
    </div>

    <div className="md:w-1/2">
      <img
        src={missionImg}
        alt="Notre mission"
        className="w-full h-full max-h-[320px] md:max-h-[360px] object-cover rounded-3xl shadow-sm"
      />
    </div>
  </div>
</section>

{/* Notre vision */}
<section className="pb-12 md:pb-16">
  <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center gap-8 md:gap-12">
    <div className="md:w-1/2">
      <img
        loading="lazy"
        src={visionImg}
        alt="Notre vision"
        className="w-full h-full max-h-[320px] md:max-h-[360px] object-cover rounded-3xl shadow-sm"
      />
    </div>

    <div className="md:w-1/2">
      <h2 className="text-2xl md:text-3xl font-bold text-[#49628b] mb-4">
        Notre vision
      </h2>
      <p className="text-sm md:text-base leading-relaxed text-slate-700">
        Notre vision est de redéfinir le paysage du courtage d'assurance grâce
        à l'innovation, à l'intégrité et à un souci constant du bien-être de
        nos clients. Nous aspirons à être le choix privilégié pour les
        solutions d'assurance, en offrant une expertise inégalée et un service
        client incomparable. En évoluant continuellement et en embrassant le
        changement, nous nous efforçons de rester en avance, en veillant à ce
        que nos clients disposent toujours de la meilleure protection
        disponible.
      </p>
    </div>
  </div>
</section>

{/* Nos produits et services */}
<section className="py-12 md:py-10 bg-white">
  <div className="max-w-6xl mx-auto px-4 sm:px-6">
    <h2 className="text-2xl md:text-3xl font-bold text-center text-[#49628b]">
      Nos produits et services
    </h2>
    <p className="mt-3 text-sm md:text-base text-center text-slate-700">
      Nous offrons une gamme complète d'options d'assurance personnelle
      conçues pour vous protéger, vous et vos proches.
    </p>

    <div className="mt-10 space-y-8">
      {/* Rangée 1 : Vie + Voyage */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Carte assurance vie */}
        <div className="bg-[#f5f7fb] rounded-[32px] border border-slate-100 shadow-sm px-8 py-8 md:px-10 md:py-10 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
          <h3 className="text-xl md:text-2xl font-semibold text-[#49628b] text-center mb-5">
            Assurance vie
          </h3>
          <ul className="space-y-2.5 md:space-y-3 text-sm md:text-base text-slate-700">
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie-temporaire"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie temporaire
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie-permanente"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie permanente
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie-permanente-participante"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie permanente avec participation
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie-entiere"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie entière
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-vie-universelle"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance vie universelle
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-hypothecaire"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance hypothécaire
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-sans-examen-medical"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance sans examen médical
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-enfants"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance enfants
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-maladie"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance santé
              </Link>
            </li>
          </ul>
        </div>

        {/* Carte assurance voyage */}
        <div className="bg-[#f5f7fb] rounded-[32px] border border-slate-100 shadow-sm px-8 py-8 md:px-10 md:py-10 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
          <h3 className="text-xl md:text-2xl font-semibold text-[#49628b] text-center mb-5">
            Assurance voyage
          </h3>
          <ul className="space-y-2.5 md:space-y-3 text-sm md:text-base text-slate-700">
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-visiteurs-canada"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance visiteurs au Canada
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-super-visa"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance super visa
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-nouveaux-arrivants"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance nouveaux arrivants
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-etudiants-internationaux"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance étudiants internationaux
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-voyage"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance voyage
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Rangée 2 : Prestations du vivant + Investissements */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Carte Prestations du vivant */}
        <div className="bg-[#f5f7fb] rounded-[32px] border border-slate-100 shadow-sm px-8 py-8 md:px-10 md:py-10 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
          <h3 className="text-xl md:text-2xl font-semibold text-[#49628b] text-center mb-5">
            Prestations du vivant
          </h3>
          <ul className="space-y-2.5 md:space-y-3 text-sm md:text-base text-slate-700">
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-invalidite"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance invalidité
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/assurance-maladies-graves"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                Assurance maladies graves
              </Link>
            </li>
          </ul>
        </div>

        {/* Carte Investissements */}
        <div className="bg-[#f5f7fb] rounded-[32px] border border-slate-100 shadow-sm px-8 py-8 md:px-10 md:py-10 transition-all duration-200 hover:shadow-md hover:-translate-y-1">
          <h3 className="text-xl md:text-2xl font-semibold text-[#49628b] text-center mb-5">
            Investissements
          </h3>
          <ul className="space-y-2.5 md:space-y-3 text-sm md:text-base text-slate-700">
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/regime-epargne-retraite"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                REER
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/regime-epargne-etudes"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                REEE
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/compte-epargne-premier-logement"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                CELIAPP
              </Link>
            </li>
            <li className="group flex items-center gap-3 py-1 px-2 rounded-lg transition-all duration-200 hover:bg-white hover:shadow-sm">
              <CheckCircle
                className="text-sky-500 transition-colors duration-200 group-hover:text-sky-600"
                size={20}
                strokeWidth={2.3}
              />
              <Link
                to="/fr/compte-epargne-libre-impot"
                className="transition-colors duration-200 group-hover:text-[#0f3b66]"
              >
                CELI
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Pourquoi choisir einsured.ca */}
<section
  className="relative py-20 sm:py-24 md:py-24 px-4 sm:px-6 md:px-24 bg-cover bg-center md:bg-fixed"
  style={{ backgroundImage: `url(${img10})` }}
>
  <div className="absolute inset-0 bg-sky-900 bg-opacity-75"></div>

  <div className="relative z-10 max-w-6xl mx-auto">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-10 sm:mb-12">
      Pourquoi choisir einsured.ca ?
    </h2>

    {/* Rangée supérieure : 3 cartes */}
    <div className="grid grid-cols-1 gap-6 lg:gap-8 lg:grid-cols-3">
      {/* Expertise et expérience */}
      <div className="bg-white/95 rounded-[32px] shadow-lg border border-slate-200 px-8 py-8 sm:px-10 sm:py-10">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#49628b] text-center mb-4">
          Expertise et expérience
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-slate-700">
          Notre équipe est composée de professionnels chevronnés de
          l'assurance qui apportent une grande richesse de connaissances et
          d'expertise. Avec plus de 12 ans d'expérience combinée, nous avons
          les compétences et la compréhension nécessaires pour naviguer dans
          les complexités du marché de l'assurance, en veillant à ce que vous
          receviez les meilleurs conseils et la meilleure couverture possible.
        </p>
      </div>

      {/* Solutions personnalisées */}
      <div className="bg-white/95 rounded-[32px] shadow-lg border border-slate-200 px-8 py-8 sm:px-10 sm:py-10">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#49628b] text-center mb-4">
          Solutions personnalisées
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-slate-700">
          Nous reconnaissons que chaque client a des besoins d'assurance
          uniques. C'est pourquoi nous prenons le temps d'écouter vos
          exigences spécifiques et d'adapter nos services en conséquence. Que
          vous cherchiez une assurance personnelle, une couverture
          professionnelle ou des polices spécialisées, nous sommes là pour
          créer un forfait qui correspond parfaitement à votre vie.
        </p>
      </div>

      {/* Offres complètes */}
      <div className="bg-white/95 rounded-[32px] shadow-lg border border-slate-200 px-8 py-8 sm:px-10 sm:py-10">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#49628b] text-center mb-4">
          Offres complètes
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-slate-700">
          De l'assurance santé et vie aux prestations du vivant, einsured.ca
          offre un large éventail de plans d'assurance. Nous nous associons
          aux principaux assureurs pour vous proposer une sélection de
          polices de haute qualité qui correspondent à vos besoins et à votre
          budget.
        </p>
      </div>
    </div>

    {/* Rangée inférieure : 2 cartes */}
    <div className="mt-6 lg:mt-8 grid grid-cols-1 gap-6 lg:gap-8 lg:grid-cols-2">
      {/* Service exceptionnel */}
      <div className="bg-white/95 rounded-[32px] shadow-lg border border-slate-200 px-8 py-8 sm:px-10 sm:py-10">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#49628b] text-center mb-4">
          Service exceptionnel
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-slate-700">
          La satisfaction des clients est au cœur de tout ce que nous
          faisons. Notre équipe est dédiée à fournir un service réactif et
          attentif à chaque interaction. Nous sommes là pour répondre à vos
          questions, vous guider tout au long du processus de réclamation et
          vous offrir un soutien chaque fois que vous en avez besoin.
        </p>
      </div>

      {/* Engagement envers l'intégrité */}
      <div className="bg-white/95 rounded-[32px] shadow-lg border border-slate-200 px-8 py-8 sm:px-10 sm:py-10">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#49628b] text-center mb-4">
          Engagement envers l'intégrité
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-slate-700">
          Chez{" "}
          <a
            href="/"
            className="text-[#49628b] underline hover:text-[#1e3a63]"
          >
            einsured.ca
          </a>
          , nous opérons avec les plus hauts standards d'intégrité et
          d'éthique professionnelle. Vous pouvez nous faire confiance pour
          agir dans votre meilleur intérêt en tout temps, en offrant des
          conseils honnêtes et une tarification transparente sans frais
          cachés ni arrière-pensées.
        </p>
      </div>
    </div>
  </div>
</section>

{/* Contactez-nous */}
<section className="py-16 md:py-20 bg-white">
  <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
    <h2 className="text-2xl md:text-3xl font-bold text-[#49628b]">
      Contactez-nous
    </h2>

    <p className="mt-4 text-sm md:text-base text-slate-700">
      Prêt à découvrir la différence einsured.ca ?
    </p>
    <p className="mt-2 text-sm md:text-base text-slate-700">
      Laissez-nous vous guider dans le labyrinthe des options d'assurance pour trouver la couverture parfaite pour vos besoins.
    </p>
    <p className="mt-2 text-sm md:text-base text-slate-700">
      Contactez-nous dès aujourd'hui pour{" "}
      <a
        href="https://book.einsured.ca/widget/bookings/ei-team"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#49628b] underline hover:text-[#1e3a63]"
      >
        planifier une consultation
      </a>{" "}
      ou en savoir plus sur nos services.
    </p>
    <p className="mt-2 text-sm md:text-base text-slate-700">
      Ensemble, protégeons ce qui compte le plus.
    </p>

    {/* Carte */}
    <div className="mt-10">
      <div className="bg-[#f5f7fb] border border-slate-200 rounded-[32px] shadow-sm px-6 sm:px-10 py-8 sm:py-10 text-center">
        <p className="text-sm md:text-base font-semibold text-[#49628b]">
          Chez <span className="font-bold">einsured.ca</span>, nous sommes bien plus qu'un courtier – nous sommes vos alliés de confiance pour assurer un avenir sûr et prospère.
        </p>
        <p className="mt-4 text-sm md:text-base text-slate-700">
          N'hésitez pas à contacter notre équipe de soutien à{" "}
          <a
            href="mailto:info@einsured.ca"
            className="font-semibold text-[#49628b]"
          >
            info@einsured.ca
          </a>{" "}
          ou appelez-nous directement au{" "}
          <span className="font-semibold text-[#49628b]">
            +1 (416) 840-0128
          </span>
          . Notre équipe est disponible du lundi au vendredi de 10 h à 18 h HNE pour vous aider.
        </p>
      </div>
    </div>

    {/* Bouton d'appel à l'action */}
    <div className="mt-10">
      <a
        href="https://book.einsured.ca/widget/bookings/ei-team"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block px-10 py-3.5 rounded-full text-sm md:text-base font-semibold text-white bg-[#00C2FF] hover:bg-[#00AEE5] shadow-md transition w-full sm:w-auto text-center"
      >
        Contactez-nous maintenant !
      </a>
    </div>
  </div>
</section>

    </div>
    </>
  );
}

export default AboutUs;
